var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-v4"},[_c('el-pagination',{attrs:{"current-page":_vm.current_page,"page-sizes":_vm.pageOptions,"page-size":_vm.per_page,"layout":_vm.layout,"total":_vm.totalRows},on:{"size-change":_vm.selPage,"current-change":_vm.pageSel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }